import { Button, UploadFileDialog } from "@/shared/components";
import { normalizeError } from "@/shared/utils";
import { useUploadRijtijden } from "@/features/tvv/hooks";

export function UploadRijtijden() {
    const uploadRijtijden = useUploadRijtijden();

    async function handleFileUpload(file: File) {
        try {
            await uploadRijtijden.mutateAsync(file);
        } catch (error) {
            throw normalizeError(error);
        }
    }

    return (
        <UploadFileDialog
            title="Upload TVV rijtijden"
            label="TVV rijtijden"
            allowedExtensions={["csv"]}
            handleFileUpload={handleFileUpload}
            isPending={uploadRijtijden.isPending}
        >
            <Button variant="secondary">Upload TVV rijtijden</Button>
        </UploadFileDialog>
    );
}
